import { POST, PUT, SUCCESS, FAILURE } from "../utils/const/http-const";
import { BASE_URL } from "../utils/const/base-url";
import { getHeaders } from "./utils";
import moment from "moment";

export async function verificarNombreYNitEmpresa(obj) {
  try {
    let data = { error: true };
    const { status, body, message } = await fetch(
      `${BASE_URL}/usuario/verificar-nombre-y-nit-empresa`,
      {
        headers: getHeaders(false),
        method: POST,
        body: JSON.stringify(obj),
      }
    ).then((res) => res.json());
    // console.log('status');
    // console.log(status);
    // console.log('body');
    // console.log(body);
    // console.log('message');
    // console.log(message);
    if (status === SUCCESS) {
      data.error = false;
      data.body = body;
    }
    if (status === FAILURE) {
      data.error = true;
      data.message = message;
      data.body = null;
    }
    // console.log('data');
    // console.log(data);
    return data;
  } catch (err) {
    console.log("verificarNombreYNitEmpresa err");
    console.log(err);
    return { error: true, message: err };
  }
}

export async function validarNombreUsuario(obj) {
  try {
    let data = { error: true };
    const { status, body, message } = await fetch(
      `${BASE_URL}/usuario/validar-nombre-usuario`,
      {
        headers: getHeaders(false),
        method: POST,
        body: JSON.stringify(obj),
      }
    ).then((res) => res.json());
    // console.log('status');
    // console.log(status);
    // console.log('body');
    // console.log(body);
    // console.log('message');
    // console.log(message);
    if (status === SUCCESS) {
      data.error = false;
      data.body = body;
    }
    if (status === FAILURE) {
      data.error = true;
      data.message = message;
      data.body = null;
    }
    // console.log('data');
    // console.log(data);
    return data;
  } catch (err) {
    console.log("validarNombreUsuario err");
    console.log(err);
    return { error: true };
  }
}

export async function registrarEmpresa(obj) {
  try {
    let data = { error: true };
    const { status, body, message } = await fetch(
      `${BASE_URL}/usuario/registrar-empresa`,
      {
        headers: getHeaders(false),
        method: POST,
        body: JSON.stringify(obj),
      }
    ).then((res) => res.json());
    // console.log('status');
    // console.log(status);
    // console.log('body');
    // console.log(body);
    // console.log('message');
    // console.log(message);
    if (status === SUCCESS) {
      data.error = false;
      data.body = body;
    }
    if (status === FAILURE) {
      data.error = true;
      data.message = message;
      data.body = null;
    }
    // console.log('data');
    // console.log(data);
    return data;
  } catch (err) {
    console.log("registrarEmpresa err");
    console.log(err);
    return { error: true };
  }
}